import FormattedMessage from 'I18n/components/FormattedMessage';
import { EERIE } from 'HubStyleTokens/colors';
import UIIllustration from 'UIComponents/image/UIIllustration';
import StyledZeroState from './StyledZeroState';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const eerieStyle = {
  color: EERIE
};
const message = inboxName => {
  return inboxName && inboxName.length > 0 ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-inbox-ui.thread-search-and-filtering.zero-states.zeroState",
    options: {
      inboxName
    }
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-inbox-ui.thread-search-and-filtering.zero-states.noInboxName"
  });
};
const SearchResultsZeroState = ({
  inboxName
}) => /*#__PURE__*/_jsxs(StyledZeroState, {
  children: [/*#__PURE__*/_jsx(UIIllustration, {
    name: "empty-state-charts",
    width: "200px"
  }), /*#__PURE__*/_jsx("h5", {
    style: eerieStyle,
    className: "m-all-6 text-center",
    children: message(inboxName)
  })]
});
SearchResultsZeroState.displayName = 'SearchResultsZeroState';
export default SearchResultsZeroState;